<template>
  <div v-if="!failed">
    <div v-show="loaded" :style="'height: ' + computedWidth + 'px; width: ' + defaultWidth + 'px'" >
      <div :id="viewerName" ref="viewer" class="osd-viewer" @click="handleClick"></div>
    </div>
    <div
    v-if="!loaded"
    style="
      position: absolute;
      top: 0; left: 0;
      width: 100%; height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255,255,255,0.8);
      z-index: 10;
    "
    >
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    />
    </div>
  </div>
</template>

<script>

const OpenSeadragon = window.OpenSeadragon;
const Annotorious = window.Annotorious;
const SelectorPack = window.AnnotoriousSelectorPack;
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    masterImageID: {
      type: Number,
      required: true
    },
    annotations: {
      type: Array,
      required: false,
      default: () => []
    },
    width: {
      type: Number,
      required: false,
      default: 150
    },
    viewerName: {
      type: String,
      required: true
    }


  },
  data() {
    return {
      viewerImg: null,
      annotoriousplugin: null,
      defaultWidth: 150,
      computedWidth: 150,
      loaded: false,
      failed: false
    };
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    imgViewerName() {
      return "tile-" + this.url
    },


  },
  methods: {
    handleClick() {
    }
  },
  mounted() {
    console.log("thumbnail mounted", this.url, this.viewerName, this.annotations, this.masterImageID, this.$store.state.user.sessionID);
    this.viewerImg = OpenSeadragon({
      id: this.viewerName,
      prefixUrl: '/static/',
      tileSources: this.url,
      showNavigationControl: false,
      showNavigator: false,
      showZoomControl: false,
      mouseNavEnabled: false,
      handleGesture: true,
      zoomPerScroll: false, // Scroll-Zoom deaktivieren
      minZoomLevel: 1, // Keine ungewollte Vergrößerung
      defaultZoomLevel: 1, // Start-Zoom auf 1 setzen
      ...(this.user.sessionID && this.user.sessionID !== "" && {
          ajaxWithCredentials: true,
          loadTilesWithAjax: true,
          tileRequestHeaders: { "Authorization": `Bearer ${this.user.sessionID}` },
          ajaxHeaders: { "Authorization": `Bearer ${this.user.sessionID}` }
        })
    })
    const canvases = document.getElementsByClassName('openseadragon-canvas')
    for (const canvas of canvases)  {
      canvas.style.touchAction = 'pan-y'
    }
    const annotationLayers = document.getElementsByClassName('a9s-annotationlayer')
    for (const canvas of annotationLayers){
      canvas.style.touchAction = 'pan-y'
      // canvas.addEventListener('touchstart', this.handleTouchStart);
      // canvas.addEventListener('touchmove', this.handleTouch);
    }
    this.viewerImg.addHandler("open", () => {
      this.$log.debug("opened" + this.url);
      this.loaded = true
      const tileSource = this.viewerImg.world.getItemAt(0).source;
      const aspectRatio = tileSource.width / tileSource.height;

      // verfügbare Breite im Eltern-Element
      const availableWidth = this.$el.parentElement.offsetWidth * 0.98;

      // Containerbreite = volle verfügbare Breite
      this.defaultWidth = availableWidth;

      // Containerhöhe = Breite * (h/w)
      this.computedWidth = availableWidth / aspectRatio;
    });
    this.viewerImg.addHandler("tile-load-failed", () => {
      this.failed = true
    });
    this.viewerImg.addHandler("open-failed", (event) => {
      this.failed = true
    });
    let annotations = []
    for (const annotation of this.annotations){
      const imageID = parseInt(annotation.image.split(".")[0])
      this.$log.debug("imageID", imageID, this.masterImageID)
      if (imageID == this.masterImageID){
        this.$log.debug("adding annotation", annotation)
        annotations.push(JSON.parse(annotation.w3c))

      }
    }
    if (annotations.length > 0){
      var MyHighlightFormatter = function(annotation) {
        return {
          'style': 'stroke-width:0px;stroke: gold;  fill: rgba(0, 128, 0,0.25);vector-effect: none;'
        }
      }
      // var MyHighlightFormatter = function(annotation) {
      //   if (annotation.motivation === "highlight"){
      //     return "highlight"
      //   } else {
      //     return "hide"
      //   }
      // }
      const _self = this
      // this.viewerImg.addViewerInputHook({ hooks: [
      //   {tracker: 'viewer',
      //     handler: 'scrollHandler',
      //     hookHandler: function (event) {
      //       _self.$log.debug("scrollHandler");
      //       // event.preventDefaultAction = true;
      //       // event.stopHandlers = true;
      //       // display meta key warning
      //       _self.toggleOverlay();
      //       setTimeout(function(){
      //         _self.toggleOverlay();
      //       }, 2000);
      //       return true;
      //     }
      //   },
      // ]});
      // // Handle drag scroll.
      // // Only works if touch-action: pan-y else scroll event doesn't propigate to documen
      // this.viewerImg.addViewerInputHook({ hooks: [
      //   {tracker: 'viewer',
      //     handler: 'dragHandler',
      //     hookHandler: function (event) {
      //     // if mobile disable drag event
      //     // pinch event handles panning with 2 fingers
      //       _self.$log.debug("dragHandler", event);
      //       _self.$log.debug("overlay true", event);
      //       _self.toggleOverlay()
      //       event.stopPropagation = true
      //       event.stopHandlers = true;
      //       setTimeout(function(){
      //         _self.toggleOverlay();
      //       }, 2000);
      //       return true;
      //     }},
      // ]});

      // // Finally, remove the instructions on any pinch event.
      // // This covers both mouse and touch devices
      // this.viewerImg.addViewerInputHook({ hooks: [
      //   {tracker: 'viewer',
      //     handler: 'pinchHandler',
      //     hookHandler: function (event) {
      //       _self.$log.debug("pinchHandler", event);
      //       return true;
      //     }},
      // ]});

      var config = {};
      config["readOnly"] = true;
      config["widgets"] = ['COMMENT', { widget: 'TAG', vocabulary: [], showDelete: false }]
      config["image"] = this.viewerAnnos;
      config["formatters"] = [MyHighlightFormatter];
      this.annotoriousplugin = window.OpenSeadragon.Annotorious(this.viewerImg, config)
      Annotorious.SelectorPack(this.annotoriousplugin);
      this.annotoriousplugin.disableEditor = true
      this.annotoriousplugin.setAnnotations(annotations)
    }
  }
};
</script>

<style scoped>
.resContainer {
  position: relative;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.15); /* Leichter Schatten */
  border-radius: 8px; /* Abgerundete Ecken */
  overflow: hidden;
}
.container.hovered {
  box-shadow: 4px 8px 12px rgba(0, 0, 0, 0.3);
  transform: scale(1.05);
}

.nopic-container {
  height: 300px;
  background-color: lightgray;
}

.osd-viewer {
  width: 100%;
  height: 100%;
  background-color: white;
}

.overlay {
  display: contents;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(103, 103, 103, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.touch-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: transparent;
}
.overlay a {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: auto;
}
.no-pic-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay-link {
  height: fit-content;
  display: block;
  width: 100%;
  text-align: center;
  color: white;
  text-decoration: none;
}
</style>
